// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__QwzFJ","left":"InfoRow_left__2weVT"};